import type { LocaleType } from '@benzinga/translate';

export const resolveHubNavEnabled = (locale: LocaleType): boolean => locale === 'en';
